const Empty = () => {
	return (
		<div>
			This page intentionally left blank.
		</div>
	)
}

export default Empty
